import { FC } from 'react'

import { IIconProps } from '../IIconProps'

export const CompletedIcon: FC<IIconProps> = ({ width = 24, height = 24, viewBox }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox || '0 0 256 256'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="128" cy="128" r="125" fill="#2dbf6f" />
      <path d="M108 170L68 130L80 118L108 146L176 78L188 90L108 170Z" fill="white" />
    </svg>
  )
}
